module.exports = __webpack_public_path__ + "catalog/items/bathroom/Bath_Centre_Taps/BathCentreTaps.svg";